module.exports = "/img/_/_/_/assets/images/creeper/book/common//29.jpg?1d989233e94d1d40a7417c758fad60e8";